





















import Enumerable from "linq";
import { DialogMixin, ModelEditableMixin } from "../../../components/system";
import { Component, Mixins } from "vue-property-decorator";
import { WorkflowPresetKinds } from "../../../domain/workflow/kinds";

@Component({
  components: {
  }
})
export default class WorkflowPresetAdditionalDialog extends Mixins(ModelEditableMixin, DialogMixin) {

  data(): any {
    return {
      presetKind: null,
    };
  }
  presetKind: WorkflowPresetKinds;

  get departmentId(): string {
    return this.$store.getters.department
      ? this.$store.getters.department.id
      : null;
  }

  get isAdministratorDepartment(): boolean {
    return this.departmentId && Enumerable.from(this.$store.getters.userAuthority.administratorDepartmentIds as string[])
      .any(d => d === this.departmentId);
  }

  get isCommonItemEditable(): boolean {
    return this.$store.getters.userAuthority.commonItemEditable;
  }

  async show(): Promise<WorkflowPresetKinds> {
    return this.showModal(async () => {
      this.presetKind = null;
      
      await this.waitHidden();
      return this.presetKind;
    });
  }

  selectPersonPreset(): void {
    this.presetKind = WorkflowPresetKinds.Person;
    this.isVisible = false;
  }

  selectDepartmentPreset(): void {
    this.presetKind = WorkflowPresetKinds.Department;
    this.isVisible = false;
  }

  selectAllPreset(): void {
    this.presetKind = WorkflowPresetKinds.All;
    this.isVisible = false;
  }
}
